import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LayoutContext } from '../../../../layout-context.model';
import { AppRoutes, NavLinks } from '@app/core/routing';

@Component({
  selector: 'gb-footer-clean',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './footer-clean.component.html',
})
export class FooterCleanComponent {
  protected readonly AppRoutes = AppRoutes;
  protected readonly NavLinks = NavLinks;

  @Input({ required: true }) ctx!: LayoutContext;

  readonly year = new Date().getFullYear();
}
